module.exports = "https://ailosprod.api.hallo.app";
